import { useSortBy } from 'react-instantsearch';
import { useTranslations } from 'next-intl';
import Arrow from '@monofront/design-system/visuals/Icons/Arrow';

interface ISelectSortProps {
  items: Array<{
    label: string;
    value: string;
  }>;
  setIsCustomSort?: (arg: boolean) => void;
}

// This is temporary component until we do the custom one from figma in design system
const SelectSortBy: React.FC<ISelectSortProps> = ({
  items,
  setIsCustomSort,
}) => {
  const { refine } = useSortBy({ items });

  const tCatalog = useTranslations('Catalog');

  return (
    <div className="tw-relative">
      <select
        className={`
        focus-within:tw-border-tertiary
        tw-mr-2
        tw-h-11
        tw-appearance-none
        tw-rounded-lg
        tw-border
        tw-border-solid
        tw-border-blue-200
        tw-outline-none
        focus:tw-outline-none
        `}
        onChange={(event) => {
          event.preventDefault();

          if (event.target.value === 'hasCustomSort') {
            setIsCustomSort?.(true);
            refine('preprod_products');

            return;
          }

          setIsCustomSort && setIsCustomSort(false);
          refine(event.target.value);
        }}
        data-testid="SelectSort-select-2"
      >
        {items.map((item) => {
          return (
            <option
              value={item.value}
              key={item.value}
              data-testid={`SelectSort-option-${item.value}`}
              className="tw-mr-2"
            >
              {tCatalog('sortBy')} {item.label}
            </option>
          );
        })}
      </select>
      <div className="tw-pointer-events-none tw-absolute tw-right-[19px] tw-top-[11px]">
        <Arrow headDirection="bottom" width={7} height={13} />
      </div>
    </div>
  );
};

export default SelectSortBy;
